import React from "react";
import { Route, Switch } from "react-router-dom";
import Add from "./Add";
import { Forecasts } from "./forecasts/index";
import { Boms} from "./Boms/index"


function Bom({ match }) {
  const { path } = match;

  console.log(path);
  return (
    <Switch>
      <Route path={`${path}/boms`} component={Boms} />
      <Route path={`${path}/add`} component={Add} />
      <Route path={`${path}/forecasts`} component={Forecasts} />
    </Switch>
  );
}

export { Bom };
